import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '../components/Users/Login';
import UsersList from "../components/Users/List";
import UserEdit from "../components/Users/Edit";
import ProblemList from "@/components/Problem/List";
import ProblemEdit from "@/components/Problem/Edit";
import TaskList from "@/components/Task/List";
import Result from "@/components/Problem/Result";

import ProblemHeader from "@/components/Problem/Header";

import store from "../store";

Vue.use(VueRouter);

const routes = [
    { name: 'login', path: '/login', component: Login, meta: {group: 'auth'} },
    { name: 'usersList', path: '/users/', component: UsersList, meta: {requiresAuth: true, group: 'usersList'} },
    { name: 'userNew', path: '/user/new', component: UserEdit, meta: {requiresAuth: true, group: 'usersList'} },
    { name: 'userEdit', path: '/user/:id', component: UserEdit, meta: {requiresAuth: true, group: 'usersList'} },
    { name: 'problemsList', path: '/', component: ProblemList, meta: {requiresAuth: true, group: 'problemsList', title: 'Все модели'} },
    { name: 'taskList', path: '/task', component: TaskList, meta: {requiresAuth: true, group: 'taskList', title: 'Все задачи'} },
    { name: 'problemNew', path: '/problem/new', components: {default: ProblemEdit, menu: ProblemHeader}, meta: {requiresAuth: true, group: 'problemEdit'} },
    { name: 'problemEdit', path: '/:step(problem|settings|adapt|wells)/:id/:itemId?', components: {default: ProblemEdit, menu: ProblemHeader}, meta: {requiresAuth: true, group: 'problemEdit'} },
    { name: 'viewResult', path: '/predict/:id/:itemId?', component: Result, meta: {requiresAuth: true, group: 'problemEdit'}}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        await store.dispatch('loginLocalUser');
        let isNotLoggedIn = !store.getters.isLoggedIn;
        let loginTo = {
            path: '/login',
            query: { redirect: to.fullPath }
        };

        if (isNotLoggedIn) {
            next(loginTo);
        }
        else {
            let routeGroup = to.matched && to.matched[0] ? to.matched[0].meta.group : false;

            if (routeGroup && store.getters.userHasRights(routeGroup)) {
                next();
            }
            else {
                store.commit('setErrorMessage', 'Не достаточно прав!');
                next(loginTo);
            }
        }
    }
    else {
        next();
    }
})

export {router, store};